module.exports = __webpack_public_path__ + "aw.svg?0cd7e031771900e86d3fe8dcd81e5556";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/aw.svg
// module id = 982
// module chunks = 0